export default {
    accountingToken: null,
    accountingUrl: null,
    signature: null,
    role_id: null,
    user_id: null,
    companies: [],
}
